<template>
    <div class="dm-main">
        <div class="title_txt">{{$t('days_and_months')}}</div>
        <div class="block days">
            <v-card v-for="i in 7" :key="i" class="card">
                <v-card-text class="card-block">
                    <span>{{$t('ru')}}:</span>
                    <span class="card-txt">{{daysOfWeek[1].value[i]}}</span>
                </v-card-text>
                <v-divider/>
                <v-card-text class="card-block">
                    <span>{{$t('kg')}}:</span>
                    <span class="card-txt">{{daysOfWeek[0].value[i]}}</span>
                </v-card-text>
            </v-card>
        </div>
        <div></div>
        <div class="title_txt">{{$t('days_and_months2')}}</div>
        <div class="block month">
            <v-card v-for="i in 12" :key="i" class="card">
                <v-card-text class="card-block">
                    <span>{{$t('ru')}}:</span>
                    <span class="card-txt">{{months[1].value[i]}}</span>
                </v-card-text>
                <v-divider/>
                <v-card-text class="card-block">
                    <span>{{$t('kg')}}:</span>
                    <span class="card-txt">{{months[0].value[i]}}</span>
                </v-card-text>
            </v-card>
        </div>
    </div>
</template>

<script async src="https://www.googletagmanager.com/gtag/js?id=G-8S0M681ZDD"></script>
<script>
window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());
export default {
  name: 'DaysMonths',
  data () {
    return {
      daysOfWeek: [],
      months: []
    }
  },
  mounted () {
    this.daysOfWeek = [
      {
        text: this.$t('kg'),
        value: [
          '',
          'Дүйшөмбү',
          'Шейшемби',
          'Шаршемби',
          'Бейшемби',
          'Жума',
          'Ишемби',
          'Жекшемби'
        ]
      },
      {
        text: this.$t('ru'),
        value: [
          '',
          'Понедельник',
          'Вторник',
          'Среда',
          'Четверг',
          'Пятница',
          'Суббота',
          'Воскресенье'
        ]
      }
    ]
    this.months = [
      {
        text: this.$t('kg'),
        value: [
          '',
          'Учтун айы',
          'Бирдин айы',
          'Жалган куран айы',
          'Чын куран айы',
          'Бугунун айы',
          'Кулжанын айы',
          'Текенин айы',
          'Баш оона айы',
          'Аяк оона айы',
          'Тогуздун айы',
          'Жетинин айы',
          'Бештин айы'
        ]
      },
      {
        text: this.$t('ru'),
        value: [
          '',
          'Январь',
          'Февраль',
          'Март',
          'Апрель',
          'Май',
          'Июнь',
          'Июль',
          'Август',
          'Сентябрь',
          'Октябрь',
          'Ноябрь',
          'Декабрь'
        ]
      }
    ]
  }
}
</script>

<style lang="scss" scoped>
.dm-main{
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    padding: 30px;
    gap: 20px;
    align-items: center;
    .title_txt{
        font-size: 20px;
        font-weight: 600;
        text-align: center;
        line-height: 10px;
        margin-bottom: 20px;
    }
    .block{
        display: flex;
        flex-direction: row;
        gap: 12px;
        flex-wrap: wrap;
        min-width: 140px;
    }
    .days{
        max-width: 1100px;
    }
    .month{
        max-width: 950px;
    }
    .card{
        width: 145px;
        height: 175px;
    }
    .card-block{
        text-align: center;
        display: flex;
        flex-direction: column
    }
    .card-txt{
        font-weight: 600;
        text-align: center;
    }
}
</style>
